import { useState, useEffect } from 'react';
import axios from 'axios';

const apiUrl = "https://elcobradorleague.com/api";

export const usePlayerMatches = (playerId, idleague) => {
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMatches = async () => {
      if (!idleague) return;

      try {
        setLoading(true);
        setError(null);

        let url = `${apiUrl}/api.php?endpoint=matches&idleague=${idleague}`;
        if (playerId && playerId !== 0) {
          url += `&playerId=${playerId}`;
        }

        const res = await axios.get(url);
        setMatches(res.data);
      } catch (err) {
        console.error("Error fetching matches:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchMatches();
  }, [playerId, idleague]);

  return { matches, loading, error };
};